<script>
import { onMount } from 'svelte';
import { fade } from 'svelte/transition';

// Logic
import {
    lastChange
} from '../utils/stores';
import { format, parseISO, isValid } from 'date-fns'


// Bindings
let updateDate;

onMount(()=> {
    lastChange.subscribe(value => {
        if(value) {
            if(isValid(value)) {
                updateDate = value;
            } else {
                const tempDate = parseISO(value);
                if(isValid(tempDate)) {
                    updateDate = tempDate;
                } else {
                    updateDate = undefined;
                }
            }
        }
    });
})


</script>

<div class="header">
    <a href="#/"><h1>KORONAOVERSIKT</h1></a>
    <div class="subtitle-group mt-1">
        <div class="pulsating-circle"></div>
        <p>Oppdateres</p>
        <span>|</span>
        
        <p>Siste endring: 
            <span transition:fade class="date">kl. {updateDate ? format(updateDate, 'HH.mm') : '...'}</span>
        </p>
    </div>
    <div class="navbar">
        <div class="navbar-section">
            <a href="#/">Oversikt</a>
            <a href="https://www.aftenbladet.no/i/naK75a">Direktestudio</a>
            <a href="https://www.aftenbladet.no/i/aPPmkE">Regler</a>
            <a href="https://www.aftenbladet.no/tag/koronaviruset">Siste saker</a>
        </div>
    </div>
</div>
  

<style lang="scss">
.header {
    background-color: color('background');
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 3rem 0;

    h1 {
        margin: 0;
        font-weight: 800;
    }

    p {
        margin: 0;
        color: color('gray');
        .date {
            margin: 0 !important;
        }
    }
    a {
        text-decoration: none;
    }

    .subtitle-group {
        display: flex;

        span {
            margin: 0 .3rem;
            color: color('gray');
        }
    }

    .navbar {
        margin-top: .8rem;
        border-top: solid 1px color('gray-light');
        //padding: 0 3rem;
        padding-top: .5rem;
        &-section {
            width: 100%;

            a {
                font-size: fontsize("std");
                font-weight: 500;
                color: color("dark");

                padding: .2rem .2rem; 
                @include desktop {
                    padding: .2rem .5rem; 
                }
                &:hover {
                    color: color('gray');
                }
            }
        }
    }
}
</style>
